import React from 'react';
import { Grid, Card, CardMedia, CardContent, Typography, CardActions, Button, Container } from '@mui/material';

const cards = [
  {
    id: 1,
    image: 'img/1.jpeg',
    title: 'Card Title 1',
    description: 'This is a brief description for card 1.',
    link: '#',
  },
  {
    id: 2,
    image: 'img/7.jpeg',
    title: 'Card Title 2',
    description: 'This is a brief description for card 2.',
    link: '#',
  },
  {
    id: 3,
    image: 'img/8.jpeg',
    title: 'Card Title 3',
    description: 'This is a brief description for card 3.',
    link: '#',
  },
  {
    id: 4,
    image: 'img/11.jpeg',
    title: 'Card Title 4',
    description: 'This is a brief description for card 4.',
    link: '#',
  },
  {
    id: 5,
    image: 'img/13.jpeg',
    title: 'Card Title 5',
    description: 'This is a brief description for card 5.',
    link: '#',
  },
  {
    id: 6,
    image: 'img/36.jpeg',
    title: 'Card Title 5',
    description: 'This is a brief description for card 5.',
    link: '#',
  },
  {
    id: 7,
    image: 'img/17.jpeg',
    title: 'Card Title 5',
    description: 'This is a brief description for card 5.',
    link: '#',
  },
  {
    id: 8,
    image: 'img/26.jpeg',
    title: 'Card Title 5',
    description: 'This is a brief description for card 5.',
    link: '#',
  },
  {
    id: 9,
    image: 'img/24.jpeg',
    title: 'Card Title 5',
    description: 'This is a brief description for card 5.',
    link: '#',
  },
];

function Gallery() {
  return (
    <Container sx={{ paddingTop: '80px', paddingBottom: '40px' }}>
      <Grid container spacing={4} justifyContent="center">
        {cards.map((card) => (
          <Grid item xs={12} sm={6} md={3} key={card.id}> {/* Adjusted for responsiveness */}
            <Card sx={{ maxWidth: 300, margin: 'auto' }}> {/* Set card size */}
              <CardMedia
                component="img"
                height="200"
                image={card.image}
                alt={card.title}
              />
              <CardContent>
                <Typography variant="h6" component="div">
                  {card.title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {card.description}
                </Typography>
              </CardContent>
              <CardActions>
                <Button size="small" href={card.link}>
                  Read More
                </Button>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
}

export default Gallery;